import React from 'react'

const PastOrdersAdmin = () => {
  return (
    <div>
      
    </div>
  )
}

export default PastOrdersAdmin
